import * as _ from "lodash";

import { CreditRequestRowType } from "src/modules/credit-request/context/CreditRequestContext";
import { IOrderLine } from "src/core/orders/api/orders.api";

import { CreditRequestEditMode } from "../context/CreditRequestContext";
import { CreditRequestStatus } from "../api/credit-request.api";
import { creditRequestCount } from "./credit-request-count";

export const validateCreditRow = (existingCredits: CreditRequestRowType[], newCredit: CreditRequestRowType, orderLine: IOrderLine, mode: CreditRequestEditMode): CreditRequestRowType => {
  // dont allow below 0
  if (newCredit.quantityRequested < 0) {
    return {
      ...newCredit,
      quantityRequested: 0
    };
  }

  if (typeof newCredit.quantityApproved === "number" && newCredit.quantityApproved < 0) {
    return {
      ...newCredit,
      quantityApproved: 0
    };
  }

  const existingCreditIndex = _.findIndex(existingCredits, cred => newCredit.localId ? cred.localId === newCredit.localId : cred.id === newCredit.id);
  const creditsValidationArray = [ ...existingCredits ];
  const existingCredit = existingCredits[ existingCreditIndex ];

  creditsValidationArray.splice(existingCreditIndex, 1, newCredit);

  const creditsByLine = _.filter(creditsValidationArray, c => c.orderLineId === newCredit.orderLineId);
  const creditsByLineCount = creditRequestCount(creditsByLine, mode === "review" ? "approved" : "requested");

  if (existingCredit) {
    if (mode === "review") {
      if (newCredit.quantityApproved && newCredit.quantityApproved > newCredit.quantityRequested) {
        return {
          ...existingCredit,
          error: "Cannot approve more then the requested amount"
        };
      }
    } else {
      if (existingCredit.quantityRequested !== newCredit.quantityRequested) {
        if (existingCredit.status && existingCredit.status !== CreditRequestStatus.PendingApproval) {
          return {
            ...newCredit,
            error: "Cannot change the quantity once a product issue has been reviewed"
          };
        }
      }
    }

    if (creditsByLineCount > orderLine.quantity) {
      return {
        ...existingCredit,
        error: "Cannot request more items on an a product then originally ordered"
      };
    }
  }

  return {
    ...newCredit,
    error: null
  };
};
